import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

// Import styles and components
import './App.css';
import ScrollToTop from '../scrolltotop'; 
import Header from '../pages/Header';
import Footer from '../pages/Footer';

// Import pages (each one is a separate screen/section)
import Home from '../pages/Home';
import Officers from '../pages/Officers';
import Events from '../pages/Events';
import Intramurals from '../pages/Intramurals';
import Luau from '../pages/Luau';
import Faq from '../pages/Faq';
import Advice from '../pages/Advice'


function App() {
  return (
    <div className="App">
      <Router>
        {/* Ensures the page scrolls to top on route change */}
        <ScrollToTop />
        
        {/* Fixed Header at the top of the page */}
        <header className="header">
          <Header />
        </header>

        {/* Main content area, routes are defined here */}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/officers" element={<Officers />} />
            <Route path="/intramurals" element={<Intramurals />} />
            <Route path="/luau" element={<Luau />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/advice" element={<Advice />} />
            {/* You can add more pages by adding new Route elements here */}
          </Routes>
        </main>

        {/* Footer at the bottom of the page */}
        <Footer />
      </Router>
    </div>
  );
}

export default App;
